import { configureStore } from "@reduxjs/toolkit";
import ApprenticeshipReducer from "../screens/apprenticeship/ApprenticeshipSlice";
import TravelAdvanceReducer from "../screens/travelAdvance/TravelAdvanceSlice";
import ParameterReducer from "../screens/parameters/ParameterSlice";
import CustomerReducer from "../screens/customer/CustomerSlice";
import EducationReducer from "../screens/education/EducationSlice";
import UsersReducer from "../screens/users/UserSlice";
import LogisticsReducer from "../screens/logistics/LogisticSlice";
import LeaseReducer from "../screens/lease/LeaseSlice";
import AppReducer from "./AppSlice";
import WalletReducer from "./WalletSlice";

export default configureStore({
	reducer: {
		app: AppReducer,
		apprenticeship: ApprenticeshipReducer,
		travelAdvance: TravelAdvanceReducer,
		parameters: ParameterReducer,
		customers: CustomerReducer,
		education: EducationReducer,
		user: UsersReducer,
		logistics: LogisticsReducer,
		lease: LeaseReducer,
		wallet: WalletReducer,
	},
});
